import { render, staticRenderFns } from "./AddAttributeDefinitionWizardControl.global.vue?vue&type=template&id=68e968ae&lang=pug&"
import script from "./AddAttributeDefinitionWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./AddAttributeDefinitionWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports